import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MIME_TYPES } from '@piqet-angular/shared';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(private http: HttpClient) {}

  // Method to open PDF in a modal
  openPdfInModal(modalService: any, docPath: string) {
    modalService.invoke('termsAndConditions', {
      initialState: {
        isVerification: true,
        pdfDoc: docPath,
      },
      class: 'modal-xl',
    });
  }

  // Method to download the PDF
  downloadPdf(docPath: string): Observable<Blob> {
    return this.http.get(docPath, { responseType: 'blob' });
  }

  openPdfInNewTab(docPath: string) {
    this.http.get(docPath, { responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        if (blob.type === MIME_TYPES.APPLICATION_JSON) {
          return;
        }

        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        window.URL.revokeObjectURL(url);
      },
      error: error => {},
    });
  }
}
